
import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/layout/Layout";
import QuickAccessSection from "@/components/dashboard/QuickAccessSection";
import MainServiceCards from "@/components/dashboard/MainServiceCards";
import { motion } from "framer-motion";

const Dashboard = () => {
  const { user } = useAuth();
  const [greeting, setGreeting] = useState("Bem-vindo");
  
  useEffect(() => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      setGreeting("Bom dia");
    } else if (currentHour < 18) {
      setGreeting("Boa tarde");
    } else {
      setGreeting("Boa noite");
    }
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
        >
          <div>
            <h1 className="text-3xl font-bold text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">
              {greeting}, {user?.nome || "usuário"}!
            </h1>
            <p className="text-gray-600 mt-2 text-sm">
              Bem-vindo ao Ecoefin, sua plataforma de gestão sustentável.
            </p>
          </div>
        </motion.div>
        
        <MainServiceCards />
        <QuickAccessSection />
      </div>
    </Layout>
  );
};

export default Dashboard;

